import Detail1 from 'images/games/pocket7games/detail1.png'
import Detail2 from 'images/games/pocket7games/detail2.png'
import Detail3 from 'images/games/pocket7games/detail3.png'
import Footer from 'images/games/pocket7games/footer.png'
import Icon from 'images/games/pocket7games/icon.png'
import Swiper1 from 'images/games/pocket7games/swiper1.webp'
import Swiper2 from 'images/games/pocket7games/swiper2.webp'
import Swiper3 from 'images/games/pocket7games/swiper3.webp'
import Swiper4 from 'images/games/pocket7games/swiper4.webp'
import Swiper5 from 'images/games/pocket7games/swiper5.webp'
import Swiper6 from 'images/games/pocket7games/swiper6.webp'
import Swiper7 from 'images/games/pocket7games/swiper7.webp'
import Swiper8 from 'images/games/pocket7games/swiper8.webp'
import {
  BingoClashLink,
  BingoTourLink,
  BlockolotLink,
  DominoesLink,
  DunkShotLink,
  EightBallStrikeLink,
  GamesLink,
  MatchNFlipLink,
  NumbersBlitzLink,
  PlaySolitaireOnlineLink,
  PoolClashLink,
  SolitaireClashLink,
  TileBlitzLink,
  TwentyOneGoldLink,
} from '../../components'
import { Pocket7GamesEntity } from './entity'
import { TemplatePageProps } from './types'

export const Pocket7GamesSwiper: TemplatePageProps['swiper'] = [
  { image: Swiper1 },
  { image: Swiper2 },
  { image: Swiper3 },
  { image: Swiper4 },
  { image: Swiper5 },
  { image: Swiper6 },
  { image: Swiper7 },
  { image: Swiper8 },
]

export const Pocket7GamesDetail: TemplatePageProps = {
  entity: {
    ...Pocket7GamesEntity,
    logo: Icon,
    title: <>Pocket7Games: Play Games That Pay Real Money</>,
    description: (
      <>
        Play Pocket7Games, the <strong>real money games app</strong> featuring skill-based <strong>casual games</strong>
        ! Experience a whole suite of thrilling real money games, right at your fingertips! Available on the App Store,
        Galaxy Store, and via APK, download now to put your skills to the test and compete for real cash prizes, all
        from the convenience of your phone!
      </>
    ),
  },
  media: {
    facebook: 'https://www.facebook.com/Pocket7Games/',
    instagram: 'https://www.instagram.com/pocket7games/',
  },
  swiper: Pocket7GamesSwiper,
  content: [
    {
      title: <>How to Play in the Pocket7Games App</>,
      description: (
        <>
          Pocket7Games features a wide range of <strong>skill games</strong>, including <BingoClashLink />,{' '}
          <MatchNFlipLink />, <TwentyOneGoldLink />, <TileBlitzLink />, <NumbersBlitzLink />, <PoolClashLink />,{' '}
          <DunkShotLink />, <DominoesLink />, and <PlaySolitaireOnlineLink /> Each game offers quick, competitive
          gameplay where your performance determines the outcome. After downloading the app, choose a game that matches
          your interests—whether it’s cards, puzzles, sports, or bingo. Enter free practice rounds to sharpen your
          skills or join cash tournaments for opportunities to win cash! You can also collect daily bonuses and play
          mini games to earn extra in-game rewards. Pocket7Games makes it easy to jump in and compete in satisfying
          gameplay anytime, anywhere.
        </>
      ),
      image: Detail1,
    },
    {
      title: <>All-in-One Real Money Games App</>,
      description: (
        <>
          Designed for players who love to play <strong>casual games</strong> during their free time, Pocket7Games is
          your all-in-one destination for skill-based <strong>cash games</strong>. The app features fast-paced
          multiplayer tournaments where you&#39;re matched with players of similar skill, making every match fair and
          square. Pocket7Games offers a variety of competitive games that reward both strategy and smart thinking! Join
          millions of players across the globe, test your skills, and turn your gaming time into opportunities to earn
          real cash!
        </>
      ),
      image: Detail2,
    },
    {
      title: <>Easy to Play, Easy to Withdraw</>,
      description: (
        <>
          Enjoy fast and secure transactions when playing <strong>real money games</strong> on the app. You can fund
          your account using trusted methods like PayPal, Venmo, Apple Pay, Visa, Mastercard, Amex, and Discover. When
          it’s time to cash out, simply request a secure withdrawal through PayPal. All transactions are encrypted and
          protected, so your personal and financial information stays safe. Pocket7Games ensures a smooth and secure
          experience every step of the way. Play confidently, knowing your money is handled carefully and backed by
          trusted payment providers.
        </>
      ),
      image: Detail3,
    },
    {
      title: <>Discover More Game Apps at Avia!</>,
      description: (
        <>
          Looking for more <strong>games that pay real money</strong>? Avia offers a full lineup of fun, skill-based
          titles beyond Pocket7Games. Try popular favorites like <SolitaireClashLink />, <BingoTourLink />,{' '}
          <EightBallStrikeLink />, <BlockolotLink />, and many more. There’s a game for every mood and skill level. Each
          title offers short, competitive matches and the opportunity to <GamesLink>play games for real cash</GamesLink>
          , making every gaming session exciting and rewarding. Explore more Avia games today and discover new ways to
          play and compete!
        </>
      ),
    },
  ],
  footer: {
    image: Footer,
  },
} as TemplatePageProps
